<form class="flex flex-col gap-6" (submit)="submit($event)">
  <div class="flex flex-col gap-3">
    <h1 class="use-grotesque m-0 text-4xl font-bold leading-none tracking-tight text-balance sm:text-5xl">Let's find your brand</h1>
    <p class="m-0 text-xl font-semibold leading-snug text-muted-foreground">Enter your website and we'll build your SHOUT workspace in seconds. No account needed yet.</p>
  </div>

  <div class="flex flex-col gap-2">
    <label for="vf-website" class="text-base font-bold">Website</label>
    <div class="flex h-14 overflow-hidden rounded-lg border border-border focus-within:border-primary focus-within:ring-2 focus-within:ring-primary/20" [class.border-red-600]="onboarding.error()">
      <span class="flex items-center border-r border-border bg-muted px-4 text-lg font-semibold text-muted-foreground">https://</span>
      <input
        id="vf-website"
        type="text"
        inputmode="url"
        autocomplete="url"
        autocapitalize="none"
        spellcheck="false"
        placeholder="yourbrand.com"
        class="min-w-0 flex-1 bg-card px-4 text-lg text-foreground outline-none placeholder:text-muted-foreground"
        [value]="onboarding.draft().url"
        (input)="onUrl($event)" />
    </div>
    @if (onboarding.error()) {
      <p class="m-0 text-base font-semibold text-red-600 dark:text-red-400" role="alert">{{ onboarding.error() }}</p>
    }
    @if (suggestions(); as brands) {
      @if (brands.length > 0) {
        <ul class="m-0 flex list-none flex-col gap-1 p-0">
          @for (brand of brands; track brand.brandId) {
            <li>
              <button
                type="button"
                class="flex w-full items-center gap-3 rounded-lg border border-border px-3 py-2 text-left hover:border-primary/40 hover:bg-primary/5"
                (click)="select(brand)">
                @if (brand.icon) {
                  <img [src]="brand.icon" alt="" class="size-8 shrink-0 rounded-md bg-muted object-cover" />
                } @else {
                  <span class="size-8 shrink-0 rounded-md bg-muted" aria-hidden="true"></span>
                }
                <span class="min-w-0 flex-1">
                  <span class="block truncate text-sm font-bold">{{ brand.name }}</span>
                  <span class="block truncate text-sm text-muted-foreground">{{ brand.domain }}</span>
                </span>
              </button>
            </li>
          }
        </ul>
      } @else {
        <p class="m-0 text-base font-semibold text-muted-foreground">Can't find your brand?</p>
      }
    }
  </div>

  <button type="button" class="self-start text-lg font-bold text-primary hover:text-primary/80" (click)="manual()">
    No website? Enter details manually
  </button>

  <p class="m-0 text-base font-semibold text-muted-foreground">Trusted by teams at Adobe, BYD, GOLIN, Pizza Hut and monday.com</p>

  <div class="fixed inset-x-0 bottom-0 z-20 border-t border-border bg-background px-5 py-3 sm:static sm:z-auto sm:border-0 sm:bg-transparent sm:p-0">
    <button type="submit" class="btn-shout btn-shout-md btn-shout-primary w-full justify-center" [disabled]="onboarding.finding()">
      @if (onboarding.finding()) {
        <span class="size-4 animate-spin rounded-full border-2 border-white/40 border-t-white" aria-hidden="true"></span>
        Analysing {{ domain() || 'your site' }}…
      } @else {
        Find my brand →
      }
    </button>
  </div>
</form>
